import { MouseEventHandler, ReactNode } from "react";

import { Box, useTheme } from "@seneca/senekit";

type Props = {
  children?: ReactNode;
  selected?: boolean;
  onClick?: MouseEventHandler;
  disabled?: boolean;
};

export default function SelectCard({
  children,
  disabled,
  selected,
  onClick
}: Props) {
  const theme = useTheme();
  return (
    <Box
      dataTest={!disabled ? "SelectCard" : "SelectCardDisabled"}
      type="button"
      opacity={disabled ? "50%" : "100%"}
      onClick={!disabled ? onClick : undefined}
      disabled={disabled}
      cursor={disabled ? "not-allowed" : "pointer"}
      backgroundColor={
        selected && !disabled
          ? theme["primary-low-surface"]
          : disabled
            ? theme["neutral-low-surface"]
            : theme.foreground
      }
      borderWidth={disabled ? "none" : "xxsmall"}
      borderStyle="solid"
      borderColor={
        selected && !disabled
          ? theme["primary-medium-content"]
          : theme["neutral-low-content"]
      }
      hoverStyles={{
        borderColor: !disabled ? theme["primary-medium-content"] : ""
      }}
      borderRadius="xlarge"
      padding="xlarge"
      maxWidth="100%"
    >
      {children}
    </Box>
  );
}
